export default `---
slug: bachelor-polimi
type: education
dateRange: "Fall 2016 – Spring 2019"
institution: "Politecnico di Milano"
location: "Milan, Italy"
role: "BSc in Automation and Control Engineering — 110/110 cum laude"
current: false
skills: [Control Theory, Mathematics, MATLAB, C, Python basics, Automation, Systems Engineering]
relatedLinks:
  - label: "University Coding Projects"
    href: /projects/university-coding
  - label: "Traffic Simulation"
    href: /projects/traffic-simulation
---

From fall 2016 to spring 2019 I completed my Bachelor in Automation and Control Engineering at Politecnico di Milano, graduating with 110/110 cum laude. I finished with an average of 30/30 across 20+ exams, with more than 50% of the exams passed with Laude — making me the student with the highest average across all students of my year (approximately 15,000 students).

This achievement earned me a scholarship offered by the PoliMi alumni circle and the honor of becoming a member of such circle. It also gave me the chance to have conversations with top managers and start a mentorship with Guglielmo Fiocchi — the youngest Vice President of Pirelli at the time — a mentorship that is still ongoing today.

A memorable moment of the bachelor: I had a class taught by the then-Dean of the university, Ferruccio Resta. He personally conducted my oral exam for that course, gave me 30/30, and complimented me on my preparation. During these years I did several cool projects that are documented in the dedicated Projects page.
`;
